const API = process.env.REACT_APP_API_URL

export async function fetchPointsLeft(): Promise<number> {
  const res = await fetch(`${API}/subscription/check`, {
    method: 'POST',
    credentials: 'include',
  })
  if (!res.ok) return Infinity
  const data = await res.json()
  return typeof data.pointsLeft === 'number' ? data.pointsLeft : Infinity
}

export async function topographSearchCompanies(countryCode: string, query: string) {
  const res = await fetch(
    `${API}/topograph/search?countryCode=${encodeURIComponent(countryCode)}&query=${encodeURIComponent(query)}`,
    {
      credentials: 'include',
    }
  )
  if (!res.ok) throw new Error(`Search failed: ${res.status}`)
  return res.json()
}

export async function topographGetDocuments(countryCode: string, companyId: string) {
  const res = await fetch(`${API}/topograph/documents`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ countryCode, companyId }),
  })
  if (!res.ok) throw new Error(`Get documents failed: ${res.status}`)
  return res.json()
}

export async function topographOrder(payload: object) {
  const res = await fetch(`${API}/topograph/order`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  })
  if (!res.ok) {
    const body = await res.json().catch(() => ({}))
    throw new Error(body?.message ?? `Order failed: ${res.status}`)
  }
  return res.json()
}
